import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "max-w-[1180px]" }
const _hoisted_2 = {
  key: 0,
  class: "overflow-x-auto p-2 -m-2"
}
const _hoisted_3 = {
  "data-test": "product-cell",
  class: "font-mono font-medium text-gray-900"
}
const _hoisted_4 = {
  "data-test": "product-cell",
  class: "flex items-center gap-1 font-medium text-gray-900"
}
const _hoisted_5 = { class: "break-words" }
const _hoisted_6 = {
  key: 0,
  "data-test": "product-breakdown",
  class: "bg-gray-50 px-4 py-2 text-sm text-gray-500"
}
const _hoisted_7 = { class: "font-mono" }
const _hoisted_8 = { class: "break-words pl-5" }

import { ChevronRightIcon } from '@heroicons/vue/20/solid'
import { computed, onMounted, reactive } from 'vue'
import { useStore } from 'vuex'

import EmptyState from '@/components/neue/EmptyState.vue'
import NeueLoading from '@/components/neue/NeueLoading.vue'
import NeueTablist from '@/components/neue/NeueTablist.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import TablistHeader from '@/components/neue/TablistHeader.vue'
import TablistRow from '@/components/neue/TablistRow.vue'
import { formatDollars } from '@/helpers/money'


export default {
  __name: 'FranchiseDayProducts',
  props: { day: { type: Object, required: true } },
  setup(__props) {

const props = __props

const COLUMNS = [{ width: '3rem' }, { width: '1fr' }, { width: '8rem' }]

const store = useStore()
const hideNumbers = computed(() => !!store.state.hideNumbers)

const dollars = cents => formatDollars(cents / 100)

const open = reactive({})
const isOpen = product => !!open[product.key]
const toggle = product => (open[product.key] = !open[product.key])

onMounted(() => props.day.loadProducts())

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NeueLoading, {
      loading: __props.day.loading.products
    }, {
      default: _withCtx(() => [
        (__props.day.products.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(NeueTablist, null, {
                head: _withCtx(() => [
                  _createVNode(TablistHeader, null, {
                    default: _withCtx(() => [
                      _createVNode(TablistGrid, {
                        columns: COLUMNS,
                        header: ""
                      }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("div", null, "Count", -1),
                          _createElementVNode("div", null, "Product", -1),
                          _createElementVNode("div", { class: "text-right" }, "Value", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.day.products.value, (product) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: product.key
                    }, [
                      _createVNode(TablistRow, {
                        "data-test": "product-row",
                        class: "cursor-pointer",
                        "aria-expanded": String(isOpen(product)),
                        onClick: $event => (toggle(product))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TablistGrid, {
                            columns: COLUMNS,
                            class: "items-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, _toDisplayString(product.quantity), 1),
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_unref(ChevronRightIcon), {
                                  class: _normalizeClass(["h-4 w-4 shrink-0 text-gray-400 transition-transform", isOpen(product) && 'rotate-90']),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"]),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(product.product_name), 1)
                              ]),
                              _createElementVNode("div", {
                                "data-test": "product-cell",
                                class: _normalizeClass(["text-right", hideNumbers.value && 'blur-sm'])
                              }, _toDisplayString(dollars(product.total_cents)), 3)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["aria-expanded", "onClick"]),
                      (isOpen(product))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.locations, (line) => {
                              return (_openBlock(), _createBlock(TablistGrid, {
                                key: `${line.merchant_id}-${line.product_id}`,
                                "data-test": "breakdown-line",
                                columns: COLUMNS,
                                class: "py-1"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(line.quantity), 1),
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(line.name), 1),
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["text-right", hideNumbers.value && 'blur-sm'])
                                  }, _toDisplayString(dollars(line.total_cents)), 3)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock(EmptyState, {
              key: 1,
              plural: "products",
              description: ""
            }))
      ]),
      _: 1
    }, 8, ["loading"])
  ]))
}
}

}